import { useMemo } from "react"
import { useUbPDPState } from "@/store/ubPDPState"

import { AttributeValueData, FullMasterProductData, VariationProductData } from "@/lib/storefront/product/product"

export const UseFilteredVariantsHook = (masterProduct: FullMasterProductData | undefined) => {
  const { selectedFilterOptions, variantSortAsc, variantIndexes } = useUbPDPState()
  const variants = masterProduct?.variants?.length
    ? masterProduct.variants
    : masterProduct?.id
      ? (variantIndexes[masterProduct.id] ?? [])
      : []

  const filteredVariants: VariationProductData[] = useMemo(() => {
    if (variants.length) {
      return variants
        .filter((v) => {
          let isInList = true
          for (const sfoAttribute in selectedFilterOptions) {
            if (isInList) {
              const sfoAttributeValue: string | undefined = selectedFilterOptions[sfoAttribute]

              const attribute = v.attributes.find((avd: AttributeValueData) => {
                //console.log(avd.attributeId)

                return avd.attributeId === sfoAttribute
              })

              if (attribute?.attributeId === sfoAttribute) {
                if (sfoAttributeValue && attribute?.value !== sfoAttributeValue) {
                  isInList = false
                }
              }
            }
          }
          return isInList
        })
        .sort((a, b) =>
          variantSortAsc ? (a.salesPrice < b.salesPrice ? -1 : 1) : a.salesPrice < b.salesPrice ? 1 : -1
        )
    } else {
      return []
    }
  }, [selectedFilterOptions, variantSortAsc, variants])

  const possibleVariants = useMemo(() => {
    const possibleVariants: Record<string, string>[] = []
    if (variants.length) {
      variants.map((vpd) => {
        const possibleVariant: Record<string, string> = {}

        //console.log(vpd.sku)
        vpd.attributes.map((avd) => {
          possibleVariant[avd.attributeId] = avd.value
        })
        possibleVariants.push(possibleVariant)
      })
      //console.dir(possibleVariants)
      return possibleVariants
    } else {
      return []
    }
  }, [variants])

  return { filteredVariants, possibleVariants }
}
